module.exports = __webpack_public_path__ + "media/images/area/map_cities_pc-e4d91d11dabb624e6ba3d467519f0191.png";